import { render } from "./NotFound.vue?vue&type=template&id=71d6f610"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=71d6f610&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__